import { skipToken } from '@tanstack/react-query';
import { useState } from 'react';
import { trpc } from '../../utils/trpc/trpc.ts';
import { CommentDialog } from './commentDialog.tsx';
import { EquipmentOption, SelectedPart } from './types.ts';


interface Props {
    style?: React.CSSProperties;
    selectedEquipment: EquipmentOption | null;
    selectedPart: SelectedPart | null;
}

export function CommentPanel({
    style,
    selectedEquipment,
    selectedPart,
}: Props) {

    const [isDialogOpen, setIsDialogOpen] = useState(false);

    const target = selectedPart?.partName
        ? { target: selectedPart.partName, targetType: 'partName' as const, displayName: selectedPart.partName }
        : selectedEquipment?.type === 'custom'
            ? { target: selectedEquipment.id, targetType: 'equipment' as const, displayName: selectedEquipment.displayName }
            : undefined;

    const { data: comment, refetch } = trpc.comments.get.useQuery(
        target ? {
            target: target.target,
            targetType: target.targetType,
        } : skipToken,
    );


    return (
        <>
            <div style={{ ...style, display: 'flex', flexGrow: 1 }}>
                <textarea
                    className='product-comment'
                    style={{ flexGrow: 1, width: 0, minWidth: 0 }}
                    readOnly
                    value={comment?.text ?? ''}
                    rows={target?.targetType === 'equipment' ? 10 : 2}
                />
                <button
                    disabled={target == null}
                    onClick={() => setIsDialogOpen(true)}
                    children='Edit'
                />
            </div>

            {(target && isDialogOpen) &&
                <CommentDialog
                    target={target.target}
                    targetType={target.targetType}
                    displayName={target.displayName}
                    initialText={comment?.text}
                    onSubmited={() => refetch()}
                    onClose={() => setIsDialogOpen(false)}
                />
            }
        </>
    );
}
